<template>
	<div class="m-meetingscene-picker">
		<van-popup v-model="vanpopup" position="bottom" :style="{ 'min-height': '30%' }" :safe-area-inset-bottom="true">
			<van-picker
				:title="$t('调研形式')"
				:confirm-button-text="$t('确定')"
				class="cus-picker"
				show-toolbar
				:default-index="defaultIndex"
				:columns="columns"
				@confirm="onConfirm"
				@cancel="onCancel"
			/>
		</van-popup>
	</div>
</template>

<script>
const meetingScene = { 1: '线上', 2: '线下' };

import { Picker, Popup } from 'vant';
export default {
	props: {
		visible: {
			type: Boolean,
			default: true
		},

		meetingScene: {
			type: Number,
			default: 0
		},
		meetingSceneList: {
			type: Array,
			default: () => []
		}
	},
	components: {
		'van-popup': Popup,
		'van-picker': Picker
	},
	data() {
		return {
			show: false
		};
	},
	computed: {
		columns() {
			return this.meetingSceneList.map(item => this.$t(meetingScene[item])) || [];
		},

		vanpopup: {
			get() {
				return this.visible;
			},
			set(value) {
				this.$emit('update:visible', value);
			}
		},

		defaultIndex() {
			return this.meetingSceneList.findIndex(item => item == this.meetingScene);
		}
	},

	methods: {
		onConfirm(value, index) {
			this.$emit('confirm', this.meetingSceneList[index]);
			this.$emit('update:visible', false);
		},
		onCancel() {
			this.$emit('update:visible', false);
		}
	}
};
</script>

<style lang="less" scoped>
.cus-picker {
	/deep/.van-picker__cancel {
		display: none;
	}
	/deep/.van-picker__title {
		padding-left: 0.14rem;
		color: #333;
		font-size: 0.15rem;
		font-weight: 500;
	}
	/deep/.van-picker__confirm {
		color: #3f5bd6;
	}
}
</style>
